
import {
  SET_USER_LOGADO,
  SET_ADRESS_USER, SET_ADRESS_TO_DELIVERY
} from "../actions/actions"

export default function (state = { nome_completo: '' }, action) {
  switch (action.type) {
    case SET_USER_LOGADO: {
      return {
        ...state,
        ...action.payload
      }
    }


    case SET_ADRESS_USER: {
      return {
        ...state,
        adress: action.payload
      }
    }

    case SET_ADRESS_TO_DELIVERY: {
      return {
        ...state,
        adressToDelivery: action.payload
      }
    }

    default: return state;
  }
}